<template>
  <div class="sales-section h-full">
    
    <!-- ENCABEZADO -->
    <div class="section-header flex justify-content-between align-items-center mb-3">
      <h3 class="section-title m-0">
        <i class="pi pi-ticket"></i> Ticket Promedio
      </h3>
      <span class="text-500 text-xs font-medium">Por unidad de pizza</span>
    </div>

    <!-- ESTADO DE CARGA -->
    <div v-if="loading" class="flex flex-column gap-3 py-2">
      <Skeleton height="4rem" class="border-round"></Skeleton>
      <Skeleton height="2.5rem" class="border-round" v-for="i in 4" :key="i"></Skeleton>
    </div>

    <!-- CONTENIDO CON DATOS -->
    <template v-else-if="totales && totales.ticket_promedio !== undefined">
      
      <!-- TICKET PROMEDIO TOTAL -->
      <div class="bg-primary-50 border-1 border-primary-200 p-3 border-round text-center mb-4">
        <span class="text-xs text-primary-700 font-bold uppercase tracking-wider block mb-1">
          TICKET PROMEDIO TOTAL
        </span>
        <span class="text-3xl font-extrabold text-primary-900">
          {{ formatearMoneda(totales.ticket_promedio) }}
        </span>
      </div>

      <!-- DESGLOSE POR CANAL -->
      <div class="flex flex-column gap-2">
        <span class="text-xs font-bold text-500 uppercase tracking-wider mb-1">
          Desglose por Canal
        </span>

        <div 
          v-for="item in detalles" 
          :key="item.canal_id" 
          class="flex align-items-center justify-content-between p-3 surface-50 border-1 surface-border border-round hover:surface-100 transition-colors"
        >
          <span class="text-sm font-semibold text-800">
            Ticket {{ item.canal }}
          </span>

          <span class="text-sm font-bold text-900">
            {{ formatearMoneda(item.ticket_promedio) }}
          </span>
        </div>
      </div>
    </template>

    <!-- ESTADO VACÍO -->
    <div v-else class="text-center py-4 text-500 flex flex-column align-items-center gap-2">
      <i class="pi pi-inbox text-3xl text-400"></i>
      <span class="text-sm">No hay registros para los filtros seleccionados.</span>
    </div>

  </div>
</template>

<script>
import Skeleton from 'primevue/skeleton';
import ReporteService from '@/service/ReporteService';

export default {
  name: 'DashboardTicketPromedio',
  components: {
    Skeleton
  },
  props: {
    fechaInicio: { type: [Date, String], default: null },
    fechaFin: { type: [Date, String], default: null },
    sucursalId: { type: [Number, String], default: null },
    grupoIds: { type: Array, default: () => [] }
  },
  data() {
    return {
      loading: false,
      totales: {},
      detalles: [],
      reporteService: null
    };
  },
  created() {
    this.reporteService = new ReporteService();
  },
  mounted() {
    this.cargarTicketPromedio();
  },
  watch: {
    fechaInicio() { this.cargarTicketPromedio(); },
    fechaFin() { this.cargarTicketPromedio(); },
    sucursalId() { this.cargarTicketPromedio(); },
    grupoIds: {
      handler() { this.cargarTicketPromedio(); },
      deep: true
    }
  },
  methods: {
    formatearMoneda(monto) {
      if (monto === null || monto === undefined || isNaN(monto)) return '0,00 Bs';
      const numero = new Intl.NumberFormat('es-BO', {
        minimumFractionDigits: 1,
        maximumFractionDigits: 2
      }).format(monto);
      return `${numero} Bs`;
    },
    formatearFechaLocal(date) {
      if (!date) return '';
      if (typeof date === 'string') return date.split(' ')[0];
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    async cargarTicketPromedio() {
      if (!this.fechaInicio || !this.fechaFin) return;
      
      this.loading = true;
      try {
        const params = {
          fecha_inicio: `${this.formatearFechaLocal(this.fechaInicio)} 00:00:00`,
          fecha_fin: `${this.formatearFechaLocal(this.fechaFin)} 23:59:59`
        };

        if (this.sucursalId) params.sucursal_id = this.sucursalId;
        if (this.grupoIds && this.grupoIds.length > 0) params.grupo_ids = this.grupoIds;

        const response = await this.reporteService.getTicketPromedio(params);

        if (response && response.totales) {
          this.totales = response.totales;
          this.detalles = response.detalles || [];
        } else {
          this.totales = {};
          this.detalles = [];
        }
      } catch (error) {
        console.error('Error al obtener el ticket promedio:', error);
        this.totales = {};
        this.detalles = [];
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.sales-section {
  background: white;
  border-radius: 8px;
  padding: 1.5rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}
.section-title {
  margin: 0 0 1rem 0;
  color: #2c3e50;
  font-size: 1.2rem;
  display: flex;
  align-items: center;
  font-weight: bold;
  gap: 0.5rem;
}
.no-data {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
</style>